import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Const from '@/util/Const'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

Vue.use(VueCookies)

const init = async () => {
  try {
    await Const.update()
  } catch (e) {
    try {
      await Const.update()
    } catch (e) {
      setTimeout(() => {
        location.reload()
      }, 2000)
    }
  }

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}

init()



